import uniqBy from 'lodash/uniqBy';

import { actions } from '@store/actions/channels';
import { actions as programActions } from '@store/actions/programs';

const channels = (state = [], action) => {
  switch (action.type) {
    case actions.set:
      return action.channels;
    case actions.add:
      return uniqBy([...state, ...action.channels], 'service_id');
    case actions.reset:
      return [];
    case programActions.add:
      return [
        ...state.map(c => {
          const actionChan = action.channels.find(
            ac => ac.service_id === c.service_id,
          );

          if (actionChan && actionChan.events) {
            Array.prototype.push.apply(c.programs, actionChan.events);
            return {
              ...c,
              programs: uniqBy(c.programs, 'uuid'),
              lastUpdate: new Date().toISOString(),
            };
          }

          return c;
        }),
      ];
    case programActions.addToSpecific: {
      const chanToUpdate = { ...state.find(c => c.service_id === action.sid) };
      const chanIndex = state.findIndex(c => c.service_id === action.sid);

      const programsToAdd = action.programs.filter(p => {
        return !chanToUpdate.programs.find(chanProg => chanProg.uuid == p.uuid);
      });

      Array.prototype.push.apply(chanToUpdate.programs, programsToAdd);

      state.splice(chanIndex, 1, {
        ...chanToUpdate,
        programs: uniqBy(chanToUpdate.programs, 'uuid'),
        lastUpdate: new Date().toISOString(),
      });

      return [...state];
    }
    case programActions.update:
      const chanToUpdate = { ...state.find(c => c.service_id === action.sid) };
      const chanIndex = state.findIndex(c => c.service_id === action.sid);
      const progToUpdate = {
        ...chanToUpdate.programs.find(p => p.uuid === action.uuid),
      };
      const progIndex = chanToUpdate.programs.findIndex(
        p => p.uuid === action.uuid,
      );

      if (chanToUpdate && progToUpdate) {
        const updatedProg = {
          ...progToUpdate,
          ...action.data,
        };
        chanToUpdate.programs.splice(progIndex, 1, updatedProg);
        state.splice(chanIndex, 1, {
          ...chanToUpdate,
          lastUpdate: new Date().toISOString(),
        });
      }

      return [...state];
    default:
      return state;
  }
};

export default channels;
